import React, { Component } from "react";
import {
  withStyles,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Snackbar,
  Tooltip,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import axios from "axios";
import { load as loadCashfree } from "@cashfreepayments/cashfree-js";
import { URL } from "../../config/config";
import { fetchPartnerDetailsSilent } from "../../store/partnerState";

const AMOUNT_CHIPS = [10000, 25000, 50000, 100000];
const MIN_AMOUNT = Number(process.env.REACT_APP_GATEWAY_MIN_AMOUNT) || 10000;
const MAX_AMOUNT = Number(process.env.REACT_APP_GATEWAY_MAX_AMOUNT) || 500000;

const INDIAN_STATES = [
  { label: "Andhra Pradesh", value: "AP" },
  { label: "Arunachal Pradesh", value: "AR" },
  { label: "Assam", value: "AS" },
  { label: "Bihar", value: "BR" },
  { label: "Chhattisgarh", value: "CG" },
  { label: "Goa", value: "GA" },
  { label: "Gujarat", value: "GJ" },
  { label: "Haryana", value: "HR" },
  { label: "Himachal Pradesh", value: "HP" },
  { label: "Jharkhand", value: "JH" },
  { label: "Karnataka", value: "KA" },
  { label: "Kerala", value: "KL" },
  { label: "Madhya Pradesh", value: "MP" },
  { label: "Maharashtra", value: "MH" },
  { label: "Manipur", value: "MN" },
  { label: "Meghalaya", value: "ML" },
  { label: "Mizoram", value: "MZ" },
  { label: "Nagaland", value: "NL" },
  { label: "Odisha", value: "OR" },
  { label: "Punjab", value: "PB" },
  { label: "Rajasthan", value: "RJ" },
  { label: "Sikkim", value: "SK" },
  { label: "Tamil Nadu", value: "TN" },
  { label: "Telangana", value: "TS" },
  { label: "Tripura", value: "TR" },
  { label: "Uttar Pradesh", value: "UP" },
  { label: "Uttarakhand", value: "UK" },
  { label: "West Bengal", value: "WB" },
  { label: "Delhi", value: "DL" },
];

const numberToWords = (num) => {
  if (num === 0 || !num) return "ZERO RUPEES";
  if (isNaN(num)) return "";
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return "";
  let str = "";
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + " Crore "
      : "";
  str +=
    n[2] != 0
      ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + " Lakh "
      : "";
  str +=
    n[3] != 0
      ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + " Thousand "
      : "";
  str +=
    n[4] != 0
      ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + " Hundred "
      : "";
  str +=
    n[5] != 0
      ? (str != "" ? "and " : "") +
        (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
        " "
      : "";
  return (str.trim() + " Rupees").toUpperCase();
};

class RechargeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0, // 0: amount, 1: billing, 2: review
      amount: 10000,
      amountError: "",
      billingDetails: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        line1: "",
        line2: "",
        city: "",
        stateCode: "",
        zip: "",
        country: "India",
        gstin: "",
      },
      billingError: "",
      breakdown: null,
      isCalculating: false,
      isCreatingOrder: false,
      isVerifying: false,
      paymentStatus: null,
      paymentMessage: "",
      isVerifyingBilling: false,
      hideForCheckout: false,
      snackbar: { open: false, message: "", severity: "info" },
    };
  }

  componentDidMount() {
    this.calculateBreakdown = this.calculateBreakdown.bind(this);
  }

  initCashfree = async () => {
    if (this._cashfreeInstance) return this._cashfreeInstance;
    this._cashfreeInstance = await loadCashfree({
      mode:
        process.env.REACT_APP_MODE === "production" ? "production" : "sandbox",
    });
    return this._cashfreeInstance;
  };

  handleAmountChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    const val = parseInt(raw) || 0;
    if (val > MAX_AMOUNT) return;
    this.setState({ amount: val, amountError: "" });
  };

  handleChipAdd = (v) =>
    this.setState((prev) => ({
      amount: Math.min(prev.amount + v, MAX_AMOUNT),
      amountError: "",
    }));

  handleReviewPayment = async () => {
    const { amount } = this.state;
    if (amount < MIN_AMOUNT) {
      this.setState({
        snackbar: {
          open: true,
          message: `Minimum transaction amount is ₹${MIN_AMOUNT.toLocaleString("en-IN")}`,
          severity: "error",
        },
      });
      return;
    }
    if (amount > MAX_AMOUNT) {
      this.setState({
        snackbar: {
          open: true,
          message: `Maximum transaction amount is ₹${MAX_AMOUNT.toLocaleString("en-IN")}`,
          severity: "error",
        },
      });
      return;
    }

    this.setState({ isVerifyingBilling: true });
    try {
      const res = await axios.post(`${URL}/api/validate-billing`, {
        amount,
      });
      this.setState({ isVerifyingBilling: false });

      if (res.data?.success && res.data?.billingRequired === false) {
        await this.calculateBreakdown();
      } else if (res.data?.success && res.data?.billingRequired === true) {
        this.setState({
          activeStep: 1,
        });
      } else {
        throw new Error("Invalid response from validation server");
      }
    } catch (error) {
      this.setState({
        isVerifyingBilling: false,
        snackbar: {
          open: true,
          message:
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Failed to validate billing",
          severity: "error",
        },
      });
    }
  };

  handleBillingField = (field, value) =>
    this.setState({
      billingDetails: { ...this.state.billingDetails, [field]: value },
      billingError: "",
    });

  validateBilling = () => {
    const bd = this.state.billingDetails;

    // Check mandatory fields deeply first
    if (!bd.firstName || !bd.firstName.trim()) return "First name is required";
    if (!bd.lastName || !bd.lastName.trim()) return "Last name is required";
    if (!bd.email || !bd.email.trim()) return "Email is required";
    if (!bd.phone || !bd.phone.trim()) return "Phone is required";
    if (!bd.line1 || !bd.line1.trim()) return "Address line 1 is required";
    if (!bd.city || !bd.city.trim()) return "City is required";
    if (!bd.stateCode || !bd.stateCode.trim()) return "State is required";
    if (!bd.zip || !bd.zip.trim()) return "Valid 6-digit PIN code is required";
    if (!bd.gstin || !bd.gstin.trim()) return "GSTIN is required";

    // Strict format validations
    if (!/^[A-Za-z\s]{2,50}$/.test(bd.firstName)) return "Invalid first name";
    if (!/^[A-Za-z\s]{2,50}$/.test(bd.lastName)) return "Invalid last name";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(bd.email))
      return "Invalid email address";
    if (!/^[6-9]\d{9}$/.test(bd.phone)) return "Invalid phone number";
    if (!/^[A-Za-z0-9\s,./'#&\-]{5,120}$/.test(bd.line1))
      return "Invalid address line";
    if (!/^[A-Za-z\s]{2,60}$/.test(bd.city)) return "Invalid city";
    if (!/^\d{6}$/.test(bd.zip)) return "Invalid PIN code";

    if (
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
        bd.gstin,
      )
    )
      return "Invalid GSTIN format";

    // Checksum validation
    // if (!this.isValidGSTIN(bd.gstin)) return "Invalid GSTIN checksum";

    return null;
  };

  isValidGSTIN = (gstin) => {
    if (!gstin || gstin.length !== 15) return false;
    const GST_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const factor = 2;
    const mod = 36;
    const gstBody = gstin.substring(0, 14);
    const checksumChar = gstin[14];

    let sum = 0;
    let multiplier = 1;
    for (let i = gstBody.length - 1; i >= 0; i--) {
      const codePoint = GST_CHARS.indexOf(gstBody[i]);
      if (codePoint === -1) return false;
      const product = codePoint * multiplier;
      sum += Math.floor(product / mod) + (product % mod);
      multiplier = multiplier === 1 ? factor : 1;
    }

    const checkCodePoint = (mod - (sum % mod)) % mod;
    const calculatedChecksum = GST_CHARS[checkCodePoint];
    return calculatedChecksum === checksumChar;
  };

  handleBillingContinue = async () => {
    const err = this.validateBilling();
    if (err) {
      this.setState({
        snackbar: { open: true, message: err, severity: "error" },
      });
      return;
    }

    try {
      this.setState({ isCalculating: true });
      const res = await axios.post(
        `${URL}/api/update-partner-billing-details`,
        {
          billingAddress: this.state.billingDetails,
        },
      );

      if (res.data?.success) {
        await this.calculateBreakdown();
      } else {
        throw new Error("Failed to save billing details");
      }
    } catch (error) {
      this.setState({
        isCalculating: false,
        snackbar: {
          open: true,
          message:
            error?.response?.data?.errorMessage ||
            error?.message ||
            "Failed to save billing details",
          severity: "error",
        },
      });
    }
  };

  calculateBreakdown = async () => {
    try {
      this.setState({ isCalculating: true, billingError: "" });
      const res = await axios.post(`${URL}/api/calculate-breakdown`, {
        amount: this.state.amount,
      });
      if (res.data?.success) {
        this.setState({
          breakdown: res.data.breakdown,
          activeStep: 2,
          isCalculating: false,
        });
      } else {
        throw new Error(res.data?.error || "Failed to calculate");
      }
    } catch (error) {
      this.setState({
        isCalculating: false,
        snackbar: {
          open: true,
          message:
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Calculation failed",
          severity: "error",
        },
      });
    }
  };

  handleProceedToPay = async () => {
    const { amount } = this.state;
    try {
      this.setState({ isCreatingOrder: true });

      const res = await axios.post(`${URL}/api/cb-recharge/create-order`, {
        amount,
      });

      if (!res.data?.success || !res.data?.paymentSessionId)
        throw new Error(res.data?.error || "Order creation failed");

      const { paymentSessionId, orderId } = res.data;
      const cashfree = await this.initCashfree();

      this.setState({ isCreatingOrder: false, hideForCheckout: true });

      const result = await cashfree.checkout({
        paymentSessionId,
        redirectTarget: "_modal",
      });

      this.setState({ hideForCheckout: false });

      if (result.error) {
        // User closed the popup or payment error
        this.setState({
          paymentStatus: "failed",
          paymentMessage: "Payment was cancelled or failed. Please try again.",
        });
      } else if (result.paymentDetails) {
        await this.verifyPayment(orderId);
      }
    } catch (error) {
      this.setState({
        isCreatingOrder: false,
        snackbar: {
          open: true,
          message:
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Payment initiation failed",
          severity: "error",
        },
      });
    }
  };

  verifyPayment = async (orderId) => {
    try {
      const prevBalance = this.props.partnerDetail?.centralBalance;
      this.setState({ isVerifying: true, prevBalance });

      await new Promise((resolve) => setTimeout(resolve, 4000));

      const res = await axios.post(`${URL}/api/cb-recharge/verify-payment`, {
        orderId,
      });
      const { status, message } = res.data;
      this.setState({
        isVerifying: false,
        paymentStatus:
          status === "paid"
            ? "success"
            : status === "payment_pending"
              ? "pending"
              : "failed",
        paymentMessage: message || "Payment verification complete.",
      });
      if (status === "paid" && this.props.fetchPartnerDetailsSilent)
        this.props.fetchPartnerDetailsSilent();
    } catch (error) {
      this.setState({
        isVerifying: false,
        paymentStatus: "failed",
        paymentMessage:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to verify payment.",
      });
    }
  };

  fmt = (val) =>
    `₹${Number(val).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  handleClose = () => {
    if (this.state.isCreatingOrder || this.state.isVerifying) return;
    this.setState({
      amount: 10000,
      amountError: "",
      activeStep: 0,
      paymentStatus: null,
      prevBalance: null,
    });
    this.props.onClose();
  };

  walletIcon = (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#6d28d9"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z" />
    </svg>
  );

  renderScreenHeader = (title) => {
    const { classes } = this.props;
    return (
      <Box className={classes.screenHeader}>
        <Box display="flex" alignItems="center" style={{ gap: 12 }}>
          <Box className={classes.screenHeaderIcon}>{this.walletIcon}</Box>
          <Typography className={classes.screenHeaderTitle}>{title}</Typography>
        </Box>
        <div onClick={this.handleClose} className={classes.screenHeaderClose}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>
      </Box>
    );
  };

  renderAmountScreen = () => {
    const { classes } = this.props;
    const { amount, isCalculating, isVerifyingBilling } = this.state;
    const disabled = !amount || isCalculating || isVerifyingBilling;
    const displayAmount = amount ? amount.toLocaleString("en-IN") : "";
    const inputWidth = displayAmount
      ? `${displayAmount.length * 26}px`
      : "32px";

    return (
      <>
        {this.renderScreenHeader("Recharge Central Balance")}

        <DialogContent className={classes.dialogContent}>
          <Box className={classes.amountInputWrapper}>
            <Typography className={classes.rupeeSymbol}>₹</Typography>
            <input
              type="text"
              value={displayAmount}
              onChange={this.handleAmountChange}
              placeholder="0"
              className={`${classes.amountInput} ${!amount ? classes.amountInputPlaceholder : ""}`}
              style={{ width: inputWidth }}
            />
          </Box>
          <Typography className={classes.wordsText}>
            {numberToWords(amount)}
          </Typography>

          <Box className={classes.chipRow}>
            {AMOUNT_CHIPS.map((c) => (
              <button
                key={c}
                className={classes.chip}
                onClick={() => this.handleChipAdd(c)}
              >
                + ₹{c.toLocaleString("en-IN")}
              </button>
            ))}
          </Box>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            variant="outlined"
            onClick={this.handleClose}
            className={classes.outlineBtn}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleReviewPayment}
            disabled={disabled}
            className={classes.primaryBtn}
          >
            {isVerifyingBilling || isCalculating ? (
              <CircularProgress size={22} style={{ color: "white" }} />
            ) : (
              "Proceed"
            )}
          </Button>
        </DialogActions>
      </>
    );
  };

  renderBillingScreen = () => {
    const { classes } = this.props;
    const { billingDetails: bd, isCalculating } = this.state;

    return (
      <>
        {this.renderScreenHeader("Billing Information")}

        <DialogContent className={classes.billingDialogContent}>
          {/* Contact Details Section */}
          <Typography className={classes.formSectionLabel}>
            CONTACT DETAILS
          </Typography>
          <div className={classes.formGrid}>
            <div>
              <input
                type="text"
                placeholder="First Name *"
                className={classes.nativeInput}
                value={bd.firstName}
                maxLength={50}
                onChange={(e) => {
                  if (/^[a-zA-Z\s]*$/.test(e.target.value))
                    this.handleBillingField("firstName", e.target.value);
                }}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Last Name *"
                className={classes.nativeInput}
                value={bd.lastName}
                maxLength={50}
                onChange={(e) => {
                  if (/^[a-zA-Z\s]*$/.test(e.target.value))
                    this.handleBillingField("lastName", e.target.value);
                }}
              />
            </div>
            <div>
              <input
                type="email"
                placeholder="Email Address *"
                className={classes.nativeInput}
                value={bd.email}
                maxLength={100}
                onChange={(e) =>
                  this.handleBillingField("email", e.target.value.trim())
                }
              />
            </div>
            <div>
              <div className={classes.phoneRow}>
                <span className={classes.phonePrefix}>+91</span>
                <input
                  type="tel"
                  placeholder="Mobile Number *"
                  className={`${classes.nativeInput} ${classes.phoneInput}`}
                  value={bd.phone}
                  maxLength={10}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value))
                      this.handleBillingField("phone", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={classes.fullSpan}>
              <input
                type="text"
                placeholder="Company / Organisation Name *"
                className={classes.nativeInput}
                value={bd.company}
                maxLength={100}
                onChange={(e) =>
                  this.handleBillingField("company", e.target.value)
                }
              />
            </div>
          </div>

          {/* Billing Address Section */}
          <Typography
            className={classes.formSectionLabel}
            style={{ marginTop: 24 }}
          >
            BILLING ADDRESS
          </Typography>
          <div className={classes.formGrid}>
            <div className={classes.fullSpan}>
              <input
                type="text"
                placeholder="Address Line 1 *"
                className={classes.nativeInput}
                value={bd.line1}
                maxLength={120}
                onChange={(e) =>
                  this.handleBillingField("line1", e.target.value)
                }
              />
            </div>
            <div className={classes.fullSpan}>
              <input
                type="text"
                placeholder="Address Line 2 (Optional)"
                className={classes.nativeInput}
                value={bd.line2}
                maxLength={120}
                onChange={(e) =>
                  this.handleBillingField("line2", e.target.value)
                }
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="City *"
                className={classes.nativeInput}
                value={bd.city}
                maxLength={60}
                onChange={(e) =>
                  this.handleBillingField("city", e.target.value)
                }
              />
            </div>
            <div>
              <select
                className={classes.nativeSelect}
                value={bd.stateCode}
                style={{ color: bd.stateCode ? "inherit" : "#6b7280" }}
                onChange={(e) => {
                  this.handleBillingField("stateCode", e.target.value);
                }}
              >
                <option value="">Select State *</option>
                {INDIAN_STATES.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <input
                type="text"
                placeholder="PIN Code *"
                className={classes.nativeInput}
                value={bd.zip}
                maxLength={6}
                onChange={(e) => {
                  if (/^\d{0,6}$/.test(e.target.value))
                    this.handleBillingField("zip", e.target.value);
                }}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="GSTIN *"
                className={classes.nativeInput}
                value={bd.gstin}
                maxLength={15}
                style={{ textTransform: "uppercase" }}
                onChange={(e) => {
                  const val = e.target.value.toUpperCase();
                  if (/^[0-9A-Z]{0,15}$/.test(val)) {
                    this.handleBillingField("gstin", val);
                  }
                }}
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            variant="outlined"
            className={classes.outlineBtn}
            onClick={() => this.setState({ activeStep: 0 })}
            disabled={isCalculating}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.primaryBtn}
            onClick={this.handleBillingContinue}
            disabled={isCalculating}
          >
            {isCalculating ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              "Save & Continue"
            )}
          </Button>
        </DialogActions>
      </>
    );
  };

  renderReviewScreen = () => {
    const { classes } = this.props;
    const { breakdown, isCreatingOrder } = this.state;
    if (!breakdown) return null;

    const gatewayTotal = Number(
      (breakdown.gatewayCharges + breakdown.gstOnGateway).toFixed(2),
    );

    return (
      <>
        {this.renderScreenHeader("Payment Summary")}

        <DialogContent
          className={classes.dialogContent}
          style={{ padding: "24px !important" }}
        >
          <Box
            className={classes.breakdownCard}
            style={{ border: "none", padding: "0" }}
          >
            <Typography
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 0.5,
                marginBottom: 16,
              }}
            >
              TRANSACTION DETAILS
            </Typography>

            {/* Credit Amount */}
            <Box className={classes.breakdownRow}>
              <Typography
                style={{ fontSize: 15, fontWeight: 600, color: "#4b5563" }}
              >
                Credit Amount
              </Typography>
              <Typography
                style={{ fontSize: 15, fontWeight: 700, color: "#1f2937" }}
              >
                {this.fmt(breakdown.baseAmount)}
              </Typography>
            </Box>

            {/* GST on Credit Amount */}
            <Box className={classes.breakdownRow}>
              <Typography
                style={{ fontSize: 15, fontWeight: 600, color: "#4b5563" }}
              >
                GST @ {(breakdown.GST_RATE * 100).toFixed(0)}%
              </Typography>
              <Typography
                style={{ fontSize: 15, fontWeight: 700, color: "#1f2937" }}
              >
                + {this.fmt(breakdown.gstOnBase)}
              </Typography>
            </Box>

            {/* TDS Deduction - only shown when TDS is charged */}
            {breakdown.tdsAmount > 0 && (
            <Box className={classes.breakdownRow}>
              <Tooltip
                interactive
                arrow
                placement="bottom-start"
                classes={{
                  tooltip: classes.gatewayTooltip,
                  arrow: classes.gatewayTooltipArrow,
                }}
                title={
                  <Typography style={{ fontSize: 11, color: "#4b5563" }}>
                    Tax Deducted at Source (2%) as per Indian tax regulations
                  </Typography>
                }
              >
                <Typography
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#4b5563",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    cursor: "pointer",
                  }}
                >
                  TDS Deduction
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#9ca3af"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ flexShrink: 0 }}
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                </Typography>
              </Tooltip>
              <Typography
                style={{ fontSize: 15, fontWeight: 700, color: "#dc2626" }}
              >
                - {this.fmt(breakdown.tdsAmount)}
              </Typography>
            </Box>
            )}

            {/* Subtotal divider */}
            <div style={{ borderTop: "1px solid #e5e7eb", margin: "16px 0" }} />

            {/* Subtotal */}
            <Box className={classes.breakdownRow}>
              <Typography
                style={{ fontSize: 15, fontWeight: 700, color: "#374151" }}
              >
                Subtotal
              </Typography>
              <Typography
                style={{ fontSize: 15, fontWeight: 700, color: "#1f2937" }}
              >
                {this.fmt(breakdown.subtotal)}
              </Typography>
            </Box>

            {/* Payment Gateway Fee with tooltip */}
            <Box className={classes.breakdownRow} style={{ marginTop: 4 }}>
              <Tooltip
                interactive
                arrow
                placement="bottom-start"
                classes={{
                  tooltip: classes.gatewayTooltip,
                  arrow: classes.gatewayTooltipArrow,
                }}
                title={
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      style={{ marginBottom: 4 }}
                    >
                      <Typography style={{ fontSize: 12, color: "#4b5563" }}>
                        Processing Fee (
                        {(breakdown.GATEWAY_RATE * 100).toFixed(0)}%)
                      </Typography>
                      <Typography
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#1f2937",
                          marginLeft: 16,
                        }}
                      >
                        {this.fmt(breakdown.gatewayCharges)}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography style={{ fontSize: 12, color: "#4b5563" }}>
                        GST on Fee ({(breakdown.GST_RATE * 100).toFixed(0)}%)
                      </Typography>
                      <Typography
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#1f2937",
                          marginLeft: 16,
                        }}
                      >
                        {this.fmt(breakdown.gstOnGateway)}
                      </Typography>
                    </Box>
                  </Box>
                }
              >
                <Typography
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#4b5563",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    cursor: "pointer",
                  }}
                >
                  Payment Gateway Fee
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#9ca3af"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ flexShrink: 0 }}
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                </Typography>
              </Tooltip>
              <Typography
                style={{ fontSize: 15, fontWeight: 700, color: "#1f2937" }}
              >
                + {this.fmt(gatewayTotal)}
              </Typography>
            </Box>

            {/* Final divider */}
            <div
              style={{ borderTop: "1px dashed #d1d5db", margin: "20px 0" }}
            />

            {/* Total Payable */}
            <Box
              style={{
                backgroundColor: "#faf5ff",
                border: "1px solid #e9d5ff",
                borderRadius: 8,
                padding: "16px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#6d28d9",
                  letterSpacing: 1,
                  textTransform: "uppercase",
                }}
              >
                Total Payable
              </Typography>
              <Typography
                style={{ fontSize: 22, fontWeight: 800, color: "#1f2937" }}
              >
                {this.fmt(breakdown.finalPayable)}
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions className={classes.screenActions}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleProceedToPay}
            disabled={isCreatingOrder}
            fullWidth
            className={classes.screenPrimaryBtn}
          >
            {isCreatingOrder ? (
              <CircularProgress size={22} style={{ color: "white" }} />
            ) : (
              `Pay ${this.fmt(breakdown.finalPayable)}`
            )}
          </Button>
        </DialogActions>
      </>
    );
  };

  renderPaymentResult = () => {
    const { classes } = this.props;
    const { paymentStatus, paymentMessage, isVerifying } = this.state;

    if (isVerifying) {
      return (
        <>
          {this.renderScreenHeader("Payment Status")}
          <DialogContent className={classes.dialogContent}>
            <Box className={classes.resultBox}>
              <CircularProgress size={36} color="primary" />
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#1f2937",
                  marginTop: 20,
                }}
              >
                Verifying Payment...
              </Typography>
              <Typography
                style={{ color: "#9ca3af", marginTop: 4, fontSize: 13 }}
              >
                Please wait while we confirm your payment
              </Typography>
            </Box>
          </DialogContent>
        </>
      );
    }

    const isSuccess = paymentStatus === "success";
    const isPending = paymentStatus === "pending";

    const iconColor = isSuccess ? "#059669" : isPending ? "#d97706" : "#dc2626";
    const title = isSuccess
      ? "Payment Successful"
      : isPending
        ? "Payment Processing"
        : "Payment Failed";

    return (
      <>
        {this.renderScreenHeader("Payment Status")}
        <DialogContent className={classes.dialogContent}>
          <Box className={classes.resultBox}>
            <Box
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                backgroundColor: isSuccess
                  ? "#ecfdf5"
                  : isPending
                    ? "#fffbeb"
                    : "#fef2f2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
              }}
            >
              {isSuccess ? (
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={iconColor}
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : isPending ? (
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={iconColor}
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              ) : (
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={iconColor}
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              )}
            </Box>

            <Typography
              style={{
                fontSize: 18,
                fontWeight: 700,
                marginTop: 16,
                color: "#1f2937",
              }}
            >
              {title}
            </Typography>

            {paymentMessage && (
              <Typography
                style={{ color: "#6b7280", marginTop: 6, fontSize: 13 }}
              >
                {paymentMessage}
              </Typography>
            )}

            {isSuccess &&
              this.state.prevBalance != null &&
              this.props.partnerDetail?.centralBalance != null &&
              this.state.prevBalance !==
                this.props.partnerDetail.centralBalance && (
                <Box
                  style={{
                    marginTop: 20,
                    backgroundColor: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: 10,
                    padding: "14px 20px",
                    width: "100%",
                    maxWidth: 300,
                    margin: "20px auto 0",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ marginBottom: 8 }}
                  >
                    <Typography
                      style={{
                        fontSize: 13,
                        color: "#6b7280",
                        fontWeight: 500,
                      }}
                    >
                      Previous Balance
                    </Typography>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#6b7280",
                      }}
                    >
                      {this.fmt(this.state.prevBalance / 100000)}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      style={{
                        fontSize: 13,
                        color: "#059669",
                        fontWeight: 600,
                      }}
                    >
                      New Balance
                    </Typography>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: "#059669",
                      }}
                    >
                      {this.fmt(
                        this.props.partnerDetail?.centralBalance / 100000,
                      )}
                    </Typography>
                  </Box>
                </Box>
              )}

            <Box mt={3} display="flex" justifyContent="center">
              {!isSuccess && !isPending ? (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.primaryBtn}
                  onClick={() =>
                    this.setState({
                      paymentStatus: null,
                      paymentMessage: "",
                      activeStep: 0,
                    })
                  }
                >
                  Try Again
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.primaryBtn}
                  onClick={this.handleClose}
                >
                  Done
                </Button>
              )}
            </Box>
          </Box>
        </DialogContent>
      </>
    );
  };

  render() {
    const { open, classes } = this.props;
    const { activeStep, paymentStatus, isVerifying, isCreatingOrder } =
      this.state;

    const showResult = paymentStatus || isVerifying;

    return (
      <>
        <Dialog
          open={open && !this.state.hideForCheckout}
          onClose={this.handleClose}
          PaperProps={{ className: classes.dialogPaper }}
          disableBackdropClick
          disableEscapeKeyDown
        >
          {/* Screens */}
          {showResult
            ? this.renderPaymentResult()
            : activeStep === 0
              ? this.renderAmountScreen()
              : activeStep === 1
                ? this.renderBillingScreen()
                : this.renderReviewScreen()}
        </Dialog>

        <Snackbar
          open={this.state.snackbar.open}
          autoHideDuration={5000}
          onClose={() =>
            this.setState((prev) => ({
              snackbar: { ...prev.snackbar, open: false },
            }))
          }
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            severity={this.state.snackbar.severity}
            onClose={() =>
              this.setState((prev) => ({
                snackbar: { ...prev.snackbar, open: false },
              }))
            }
          >
            {this.state.snackbar.message}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

const styles = (theme) => ({
  dialogPaper: {
    borderRadius: 16,
    maxWidth: 540,
    width: "100%",
    backgroundColor: "#ffffff",
    boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.15)",
    margin: 16,
  },
  dialogTitle: {
    padding: "16px 24px",
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e5e7eb",
    textAlign: "left",
  },
  titleText: {
    fontSize: 18,
    fontWeight: 600,
    color: "#0f172a",
    fontFamily: "Roboto, sans-serif",
    letterSpacing: 0,
  },

  // Shared screen header
  screenHeader: {
    padding: "24px 24px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  screenHeaderIcon: {
    backgroundColor: "#faf5ff",
    border: "1px solid #e9d5ff",
    borderRadius: "50%",
    width: 36,
    height: 36,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  screenHeaderTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
    fontFamily: "Roboto, sans-serif",
  },
  screenHeaderClose: {
    cursor: "pointer",
    color: "#9ca3af",
    padding: 4,
    display: "flex",
    borderRadius: 6,
    transition: "background 0.15s ease",
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
  },

  // Shared screen actions
  screenActions: {
    padding: "0 24px 24px",
    backgroundColor: "#ffffff",
    display: "flex",
    gap: 12,
    width: "100%",
    boxSizing: "border-box",
  },
  screenPrimaryBtn: {
    borderRadius: 12,
    padding: "14px 0",
    backgroundColor: "#5b21b6",
    fontWeight: 700,
    textTransform: "none",
    fontSize: 16,
    boxShadow: "none",
    letterSpacing: 0.3,
    "&:hover": {
      backgroundColor: "#4c1d95",
      boxShadow: "none",
    },
  },
  screenBackBtn: {
    borderRadius: 12,
    padding: "14px 24px",
    color: "#4b5563",
    borderColor: "#e5e7eb",
    fontWeight: 600,
    textTransform: "none",
    fontSize: 15,
    "&:hover": {
      backgroundColor: "#f9fafb",
      borderColor: "#d1d5db",
    },
  },

  dialogContent: {
    padding: "32px 24px 32px !important",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  billingDialogContent: {
    padding: "24px !important",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },

  // Amount Screen
  amountInputWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
    position: "relative",
  },
  rupeeSymbol: {
    fontSize: 28,
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontFamily: "Roboto, sans-serif",
    marginTop: 4,
  },
  amountInput: {
    fontSize: 46,
    fontWeight: 600,
    color: "#0f172a",
    textAlign: "left",
    border: "none",
    background: "transparent",
    outline: "none",
    width: "auto",
    maxWidth: 240,
    padding: 0,
    fontFamily: "Roboto, sans-serif",
  },
  amountInputPlaceholder: {
    color: "#0f172a",
  },
  wordsText: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.main,
    textAlign: "center",
    marginTop: 20,
    letterSpacing: 0.8,
  },
  chipRow: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginTop: 36,
    flexWrap: "wrap",
  },
  chip: {
    borderRadius: 24,
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
    padding: "8px 18px",
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: "Roboto, sans-serif",
    "&:hover": {
      background: "rgba(109, 40, 217, 0.08)",
      borderColor: "#6d28d9",
      color: "#6d28d9",
    },
  },

  // Legacy actions (kept for compatibility)
  dialogActions: {
    padding: "0 24px 24px",
    backgroundColor: "#ffffff",
    display: "flex",
    gap: 16,
    justifyContent: "space-between !important",
    width: "100%",
    boxSizing: "border-box",
  },
  outlineBtn: {
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    color: "#1e293b",
    fontSize: 13,
    fontWeight: 500,
    padding: "6px 24px",
    minWidth: 100,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  primaryBtn: {
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 500,
    padding: "6px 24px",
    minWidth: 100,
    textTransform: "none",
    boxShadow: "none",
  },

  // Billing form
  formSectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: "#9ca3af",
    letterSpacing: 0.8,
    marginBottom: 14,
    width: "100%",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  fullSpan: {
    gridColumn: "1 / -1",
  },
  nativeInput: {
    padding: "12px 16px",
    border: "1px solid #d1d5db",
    borderRadius: 10,
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    backgroundColor: "#ffffff",
    fontFamily: "Roboto, sans-serif",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "#6d28d9",
      // boxShadow: "0 0 0 3px rgba(109, 40, 217, 0.08)",
    },
    "&::placeholder": {
      color: "#9ca3af",
    },
  },
  nativeSelect: {
    padding: "12px 16px",
    border: "1px solid #d1d5db",
    borderRadius: 10,
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
    outline: "none",
    fontFamily: "Roboto, sans-serif",
    cursor: "pointer",
    textAlign: "left",
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none",
    backgroundImage: `url('data:image/svg+xml;utf8,<svg fill="%236b7280" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')`,
    backgroundRepeat: "no-repeat",
    backgroundPositionX: "calc(100% - 12px)",
    backgroundPositionY: "center",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "#6d28d9",
      // boxShadow: "0 0 0 3px rgba(109, 40, 217, 0.08)",
    },
  },
  phoneRow: {
    display: "flex",
    alignItems: "stretch",
  },
  phonePrefix: {
    display: "flex",
    alignItems: "center",
    padding: "0 14px",
    backgroundColor: "#f9fafb",
    border: "1px solid #d1d5db",
    borderRight: "none",
    borderRadius: "10px 0 0 10px",
    color: "#6b7280",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Roboto, sans-serif",
  },
  phoneInput: {
    borderRadius: "0 10px 10px 0 !important",
  },

  // Review breakdown
  breakdownCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "20px 24px",
    width: "100%",
  },
  breakdownRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
  },
  breakdownDivider: {
    borderTop: "1px dashed #d1d5db",
    margin: "12px 0",
  },
  resultBox: {
    textAlign: "center",
    padding: "40px 0",
    width: "100%",
  },
  gatewayTooltip: {
    backgroundColor: "#ffffff",
    color: "#1f2937",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "10px 14px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    maxWidth: 300,
    minWidth: 220,
  },
  gatewayTooltipArrow: {
    color: "#ffffff",
    "&::before": {
      border: "1px solid #e5e7eb",
    },
  },
});

const connectedRechargeModal = connect(null, {
  fetchPartnerDetailsSilent,
})(RechargeModal);

export default withStyles(styles)(connectedRechargeModal);
